import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Observable, debounceTime, filter, map, of, takeUntil, tap, withLatestFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { StripListHeaderComponent } from '@shared/components/strip-list/strip-list-header/strip-list-header.component';
import { StripListItemComponent } from '@shared/components/strip-list/strip-list-item/strip-list-item.component';
import { BasedComponent } from '@shared/components/based.component';
import { ToggleButtonComponent, ToggleButtonType } from '@shared/components/toggle-button';
import { ValidateUserProfile } from '@app/shared/actions/common-data.action';
import { Select, Store } from '@ngxs/store';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { NgxsActionName } from '@app/shared/constants';
import { UserProfile } from '@app/shared/classes/user-profile';
import { Utilities } from '@app/shared/utils/utilities';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-user-profile-search-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, StripListHeaderComponent, StripListItemComponent, ToggleButtonComponent, LoadingSpinnerComponent],
  templateUrl: './user-profile-search-grid.component.html',
  styleUrl: './user-profile-search-grid.component.css'
})
export class UserProfileSearchGridComponent extends BasedComponent {
  store = inject(Store);

  @Input() filterText$: Observable<string> = of('');
  @Output() itemToggled = new EventEmitter();

  ToggleButtonType = ToggleButtonType;
  selected: UserProfile;
  dataSource$: Observable<UserProfile[]>;

  @Select(AppDataState.taskResponse(NgxsActionName.VALIDATE_USER_PROFILE)) profileDataResponse$: Observable<UserProfile>;
  @Select(AppDataState.taskExecuting(NgxsActionName.VALIDATE_USER_PROFILE)) processing$: Observable<boolean>;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    this.dataSource$ = this.profileDataResponse$.pipe(withLatestFrom(this.filterText$), map(([res, filterText]) =>
      (res && !Utilities.isEmptyString(res.apexId) && res.apexId.toLocaleLowerCase() === filterText.toLocaleLowerCase()) ? [res] : []));

    this.filterText$.pipe(debounceTime(800), takeUntil(this.destroy$)).subscribe(filterText => {
      if (filterText) {
        this.selected = null;
      }

      if (filterText.length >= 3) {
        this.store.dispatch(new ValidateUserProfile(filterText));
      }
    });
  }

  itemSelected = (item: UserProfile) => {
    this.selected = item;
    this.itemToggled.emit({ item: item, toggled: true });
    this.store.dispatch(new ValidateUserProfile());
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
